import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuftragsKomponente } from 'src/app/api/model/swagger-model';
import { Auftragdetails } from '../auftragdetails.helper';
import { KomponenteBase } from './komponente';

@Component({
    selector: 'auftrag-hinweistexte-komponente',
    template: `
        <div *ngIf="auftrag.Hinweistexte && auftrag.Hinweistexte.length">
          <div class="section">
            <h1>{{ getEinstellung('Titel', 'Texte') }}</h1>

            <div *ngFor="let p of auftrag.Hinweistexte" class="hinweistext">{{ p.Inhalt }}</div>
          </div>
        </div>
    `,
    styles: [`
    .hinweistext {
        white-space: pre-line;
        padding-bottom: 15px;
    }

    .hinweistext:last-child {
        padding-bottom: 0;
    }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragHinweistexteComponent extends KomponenteBase implements OnInit {

    @Input() auftragdetails: Auftragdetails;
    @Input() komponente: AuftragsKomponente;

    constructor(
        private router: Router,
        protected cdr: ChangeDetectorRef) {
        super(cdr);
    }

    ngOnInit() {
        super.ngOnInit();
    }
}
